import React, { Component } from 'react';
import './forgot-password.scss';
import { Constants, ImageConstants } from '../../constants/constants';
import { getImageSource } from '../../utility/image-source';
import ResetPassword from './reset-password/reset-password';
import Header from '../common/header/header-component';
import Service from '../../apis/service-manager';
import Urls from '../../apis/url';
import Loading from '../common/loading/loading';



class ForgotPassword extends Component {
    state = {
        activeStep: Constants.SEND_EMAIL_PAGE,
        isNotRegisteredEmail: false,
        isInvalidOtp: false,
        loading: false
    };

    changePassword = (payload) => {

        console.log(payload)

        this.toggleLoading(true);

        Service.createData(Urls.RESET_PASSWORD, payload, (err, response) => {
            if (err) {
                this.setState({ isInvalidOtp: true });
                this.toggleLoading(false);
                return;
            }
            this.toggleLoading(false);
            this.setState({ activeStep: Constants.RESET_PASSWORD_SUCCESS_PAGE });
        });

    }

    sendEmail = (payload) => {

        this.toggleLoading(true);

        Service.createData(Urls.FORGOT_PASSWORD, payload, (err, response) => {
            if (err) {
                if (err.response.data.code == Constants.INVALID_EMAIL_ID) {
                    this.setState({ isNotRegisteredEmail: true });
                }
                this.toggleLoading(false);
                return;
            }
            this.toggleLoading(false);
            this.setState({ activeStep: Constants.RESET_PASSWORD_PAGE });
        });
    }

    resendOtp = (payload) => {
        this.sendEmail(payload);
    }

    toggleLoading = (value) => {
        this.setState({ loading: value });
    }

    removeUnRegisteredEmailErrorMessage() {
        this.setState({ isNotRegisteredEmail: false });
    }

    removeInvalidOtpErrorMesaage() {
        this.setState({ isInvalidOtp: false });
    }

    render() {
        return (
            <>
                {this.state.loading && <Loading />}
                <div className='forgot-password'>
                    <div className="cw-background-plain">
                        <div className='header row no-gutters'>
                            <div className="col-6"> <img className="logo" src={getImageSource(ImageConstants.CW_LOGO)} /></div>
                        </div>
                        <div className='row no-gutters'>
                            <div className='col-6'>
                                <img src={getImageSource(ImageConstants.FORGOT_PASSWORD)} className='forgot-password-vector-image' />
                            </div>
                            <div className="col-1"></div>
                            <div className='col-4'>
                                <ResetPassword
                                    activeStep={this.state.activeStep}
                                    isInvalidOtp={this.state.isInvalidOtp}
                                    delegate={this}
                                    isNotRegisteredEmail={this.state.isNotRegisteredEmail} />
                            </div>
                            <div className="col-1"></div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default ForgotPassword;